// extracted by mini-css-extract-plugin
export default {"account":"Account_account__NynrY","icon":"Account_icon__zTfTx","p":"Account_p__pE3aS"};